<template>
    <div>
        <p>Chargement de vos informations ...</p>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'Confirm',
        components: {},
        computed: {
            ...mapGetters({
                currentUser: 'currentUser',
                firstConnection: 'firstConnection'
            })
        },
        created() {
            this.checkCurrentLogin()
        },
        mounted() {
            this.login();
        },
        methods: {
            ...mapActions({
                updateFirstConnection: 'updateFirstConnection'
            }),
            checkCurrentLogin() {
                if (localStorage.token) {
                    this.$router.push('/')
                }
            },
            login() {
                this.$http.get('/confirm?id=' + this.$route.query.id + '&token=' + this.$route.query.token)
                    .then(request => this.loginSuccessful(request))
                    .catch(() => this.loginFailed())
            },
            loginSuccessful(req) {
                let $this = this
                if (!req.data.auth_token) {
                    this.loginFailed(req.data)
                    return
                }
                localStorage.token = req.data.auth_token
                this.$store.dispatch('login') // <=
                document.location.reload()
                //  this.updateFirstConnection(this.currentUser.firstConnection)
                //   if (this.currentUser.firstConnection) {
                //       $this.$router.push('/on-boarding')
                //   } else {
                //       $this.$router.push('/')
                //   }
                this.$router.push('/')

                //  this.redirectOnProject()
            },
            loginFailed() {
                if (this.currentUser || localStorage.token) {
                    this.$router.push('/')
                } else {
                    this.$store.dispatch('logout')
                    delete localStorage.token
                    this.$router.push('/connexion')
                }

            }
        }
    }
</script>

<style scoped lang="scss">
</style>
